// client/src/components/wetakeover/TrustedBy.jsx
import React from 'react';

const TrustedBy = () => {
  // Brand logos - priority brands first, then the rest
  const brands = [
    // Priority brands (Polygon, Secret, Pyth, Somnia, Jupiter, Pixelmoon, Kgen, Privado, OKX)
    { name: 'Polygon', logo: 'https://framerusercontent.com/images/EiK2GlQrb2PVSjgsQRYHFKEFqQg.png' },
    { name: 'Secret', logo: 'https://framerusercontent.com/images/Yq1ishKLHCrwwrIq69o1OmMm9SM.png' },
    { name: 'Pyth', logo: 'https://framerusercontent.com/images/Y2ozMl6TuhDeeiVlS7HJTzy9jgQ.png' },
    { name: 'Somnia', logo: 'https://framerusercontent.com/images/0OdjFeuZxXu20OVtGtiRsnp5BqY.png' },
    { name: 'Jupiter', logo: 'https://framerusercontent.com/images/sMTBl6mCD3wQabxkx6XqEjqgnCQ.png' },
    { name: 'Pixelmoon', logo: 'https://framerusercontent.com/images/pfddh35xCAolMS1tDb6mnn2YLs.png' },
    { name: 'Kgen', logo: 'https://framerusercontent.com/images/AjbSOtMHRt9LjdMu3AFOYLiYAY.png' },
    { name: 'Privado', logo: 'https://framerusercontent.com/images/wzJSdMzeGdqBA4IwJ53pGEXVdY.png' },
    { name: 'OKX', logo: 'https://framerusercontent.com/images/D77oaE0jg6FbJ0ZEcFIK4WE78.png' },
    // Remaining brands
    { name: 'Brand 10', logo: 'https://framerusercontent.com/images/umQH5crMU4LQxDZKQFgxy7JVSco.png' },
    { name: 'Brand 11', logo: 'https://framerusercontent.com/images/YXuPDetPgJhUeHhiV8KIn71k.png' },
    { name: 'Brand 12', logo: 'https://framerusercontent.com/images/sPguHKxkxUcKzW4wzAbCJM5Jy4.png' },
    { name: 'Brand 13', logo: 'https://framerusercontent.com/images/1UWHioywLCZ73XJtfSWMRTUv0o.png' },
    { name: 'Brand 14', logo: 'https://framerusercontent.com/images/94h5mjN5YVm7ZtYpfULFWH0KV0.png' },
    { name: 'Brand 15', logo: 'https://framerusercontent.com/images/rce2zc40yx783sq2x7oPRGPE4NA.png' },
    { name: 'Brand 16', logo: 'https://framerusercontent.com/images/rty35DWbVG0wRbkC85VHD39USPA.png' },
    { name: 'Brand 17', logo: 'https://framerusercontent.com/images/SV4E2HxdIqJWhTxaUYbCiaqloHM.png' },
    { name: 'Brand 18', logo: 'https://framerusercontent.com/images/frcmIxkmcIahxNFFXzkAiqWeZ0.png' },
    { name: 'Brand 19', logo: 'https://framerusercontent.com/images/xUO7jfZuNjinkgDUtQXjbMnzkE.png' },
    { name: 'Brand 20', logo: 'https://framerusercontent.com/images/5nNn4FuBXbE0T6s0Bqd3WENYeDA.png' },
    { name: 'Brand 21', logo: 'https://framerusercontent.com/images/J4v5jriBZsExxVDhBbJ2AylF5HI.png' },
    { name: 'Brand 22', logo: 'https://framerusercontent.com/images/lKKSBWGRCPvb7nPCYXcDuUhrE.png' },
  ];

  // Split brands for two rows
  const row1Brands = brands.slice(0, 11);
  const row2Brands = brands.slice(11);

  // Triple for seamless infinite scroll
  const row1All = [...row1Brands, ...row1Brands, ...row1Brands];
  const row2All = [...row2Brands, ...row2Brands, ...row2Brands];

  return (
    <section className="py-10 md:py-14 overflow-hidden bg-[#0d0c0d]">
      {/* Section Header */}
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-5xl font-bold text-white">
          Trusted by <span className="text-yellow-300">Leading Brands</span>
        </h2>
        <p className="text-white/50 mt-4 max-w-xl mx-auto">
          We've helped the biggest names in Web3 amplify their reach
        </p>
      </div>

      {/* Marquee Container */}
      <div className="relative">
        {/* Gradient Fade Left */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-[#0d0c0d] to-transparent z-10 pointer-events-none" />

        {/* Gradient Fade Right */}
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-[#0d0c0d] to-transparent z-10 pointer-events-none" />

        {/* First Row - Scrolling Left */}
        <div className="flex mb-6 animate-marquee-left">
          {row1All.map((brand, index) => (
            <div
              key={`row1-${index}`}
              className="flex-shrink-0 mx-6 md:mx-10"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="h-[50px] md:h-[70px] w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>

        {/* Second Row - Scrolling Right (Reverse) */}
        <div className="flex animate-marquee-right">
          {row2All.map((brand, index) => (
            <div
              key={`row2-${index}`}
              className="flex-shrink-0 mx-6 md:mx-10"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="h-[50px] md:h-[70px] w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Custom CSS for marquee animations */}
      <style>{`
        @keyframes marquee-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        @keyframes marquee-right {
          0% {
            transform: translateX(-33.333%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .animate-marquee-left {
          animation: marquee-left 40s linear infinite;
        }
        .animate-marquee-right {
          animation: marquee-right 40s linear infinite;
        }
        .animate-marquee-left:hover,
        .animate-marquee-right:hover {
          animation-play-state: paused;
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-marquee-left,
          .animate-marquee-right {
            animation: none;
            transform: none;
          }
        }
      `}</style>
    </section>
  );
};

export default TrustedBy;
